// removed by extract-text-webpack-plugin
module.exports = {"form":"c-LoginForm__form","button":"c-LoginForm__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/LoginForm/LoginForm.scss
// module id = 719
// module chunks = 0